import { Plus } from 'iconoir-react';
import { FC } from 'react';
import { useTitle } from 'react-use';

import { BUTTON_TYPES } from '@savgroup-front-common/constants';
import { Button } from '@savgroup-front-common/core/atoms/button';
import { Pagination } from '@savgroup-front-common/core/atoms/Pagination';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { buildPageTitle } from '@savgroup-front-common/core/helpers';
import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';

import { $HomeProductsListWrapper } from '../HomePage.styles';

import AddProduct from './AddProduct/AddProduct';
import HomePageProductItem from './HomePageProductItem/HomePageProductItem';
import useListOwnerProductsQuery from './HomePageProducts.hooks';
import messages from './messages';

export const HomePageProducts: FC = () => {
  const {
    products,
    isLoading,
    refetchListProduct,
    isOpen,
    setOpen,
    pagination,
    handleChangePage,
    handleChangeInterval,
  } = useListOwnerProductsQuery();

  useTitle(buildPageTitle([messages.productsTitlePage]));

  if (isLoading) {
    return <BaseLoader />;
  }

  return (
    <$HomeProductsListWrapper>
      <Button
        type={BUTTON_TYPES.BUTTON}
        primary
        hollow
        onClick={() => setOpen(true)}
        fluid
        icon={<Plus />}
      >
        <SafeFormattedMessageWithoutSpread message={messages.addProduct} />
      </Button>

      {products
        ?.slice(
          (pagination.page - 1) * pagination.pageSize,
          pagination.page * pagination.pageSize,
        )
        .map((product) => (
          <HomePageProductItem key={product.ownerProductId} product={product} />
        ))}
      <Pagination
        onChangePage={handleChangePage}
        pagination={pagination}
        onSelectInterval={handleChangeInterval}
        paginationInterval={[10, 25, 50]}
      />

      <AddProduct
        isOpen={isOpen}
        setOpen={setOpen}
        onAddProduct={refetchListProduct}
      />
    </$HomeProductsListWrapper>
  );
};
